<template>
  <footer
    id="footer"
    class="footer dark-background"
    style="backdrop-filter: blur(10px); background: #0a0e1acc"
  >
    <div class="footer-main">
      <div class="container">
        <div class="row gy-4">
          <div class="col-lg-4 col-md-6">
            <div class="footer-widget footer-about">
              <span href="/" class="logo">
                <span class="">
                  <mx3-logo force-dark />
                </span>
              </span>
              <p>
                Somos especialistas em soluções de redes e conectividade.
                Oferecemos uma ampla gama de roteadores, switches, access points
                e acessórios para atender todas as suas necessidades de rede.
              </p>

              <div class="social-links mt-4">
                <h5>Siga-nos nas Redes</h5>
                <div class="social-content">
                  <div class="social-links">
                    <a href="#" class="social-link facebook" title="Facebook">
                      <i class="bi bi-facebook"></i>
                    </a>
                    <a href="#" class="social-link instagram" title="Instagram">
                      <i class="bi bi-instagram"></i>
                    </a>
                    <a href="#" class="social-link twitter" title="Twitter">
                      <i class="bi bi-twitter-x"></i>
                    </a>
                    <a href="#" class="social-link linkedin" title="LinkedIn">
                      <i class="bi bi-linkedin"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-6">
            <div class="footer-widget">
              <h4>Produtos</h4>
              <ul class="footer-links">
                <li><a href="/">Roteadores</a></li>
                <li><a href="/">Switches</a></li>
                <li><a href="/">Access Points</a></li>
                <li><a href="/">Cabos de Rede</a></li>
                <li><a href="/">Acessórios</a></li>
                <li><a href="/">Promoções</a></li>
              </ul>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-6">
            <div class="footer-widget">
              <h4>Suporte</h4>
              <ul class="footer-links">
                <li>
                  <a href="/contato">Central de Ajuda</a>
                </li>
                <li>
                  <a href="/contato">Status do Pedido</a>
                </li>
                <li>
                  <a href="/contato">Informações de Envio</a>
                </li>
                <li>
                  <a href="/contato">Política de Trocas</a>
                </li>
                <li>
                  <a href="/contato">Guia de Instalação</a>
                </li>
                <li>
                  <a href="/contato">Fale Conosco</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="footer-widget">
              <h4>Informações de Contato</h4>
              <div class="footer-contact">
                <div class="contact-item">
                  <i class="bi bi-geo-alt"></i>
                  <span
                    >R. Empresário João Rodrigues Alves, n° 125 (302b e 604b) -
                    Bancários, João Pessoa - PB, 58051-022</span
                  >
                </div>
                <div class="contact-item">
                  <i class="bi bi-telephone"></i>
                  <span>(83) 9 9149-3136</span>
                </div>
                <div class="contact-item">
                  <i class="bi bi-envelope"></i>
                  <span>contato@mx3network.com</span>
                </div>
                <div class="contact-item">
                  <i class="bi bi-clock"></i>
                  <span
                    >Segunda-Sexta: 8h-18h<br />Sábado: 9h-13h<br />Domingo:
                    Fechado</span
                  >
                </div>
              </div>

              <div class="app-buttons mt-4">
                <a href="#" class="app-btn" id="btnInstall">
                  <i class="bi bi-apple"></i>
                  <span>App Store</span>
                </a>
                <a href="#" class="app-btn" id="btnInstall2">
                  <i class="bi bi-google-play text-success"></i>
                  <span>Google Play</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container">
        <div class="row gy-3 align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="copyright">
              <p>
                © <span>Copyright</span>
                <strong class="sitename text-primary">&nbsp;MX3 Network</strong
                >. Todos os direitos reservados.
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div
              class="d-flex flex-wrap justify-content-lg-end justify-content-center align-items-center gap-4"
            >
              <div class="payment-methods">
                <div class="payment-icons">
                  <img
                    src="/assets/img/logos/visa.png"
                    alt="visa"
                    style="height: 25px; background-color: white !important"
                    class="rounded"
                  />
                  <img
                    src="/assets/img/logos/master.png"
                    alt="master"
                    style="height: 25px; background-color: white !important"
                    class="rounded"
                  />
                  <img
                    src="/assets/img/logos/itau.png"
                    alt="itau"
                    style="height: 25px; background-color: white !important"
                    class="rounded"
                  />
                  <img
                    src="/assets/img/logos/pix.png"
                    alt="pix"
                    style="
                      height: 25px;
                      width: 35px;
                      background-color: white !important;
                    "
                    class="rounded"
                  />
                  <img
                    src="/assets/img/logos/boleto.png"
                    alt="boleto"
                    style="height: 25px; background-color: white !important"
                    class="rounded"
                  />
                </div>
              </div>

              <div class="legal-links">
                <a href="/termos" @click.prevent="$router.push('/termos')">Termos</a>
                <a href="/privacidade" @click.prevent="$router.push('/privacidade')">Privacidade</a>
                <a href="/cookies" @click.prevent="$router.push('/cookies')">Cookies</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import templateMixin from "../mixins/templateMixin";

// export default {
//   name: "Footer",
//   mixins: [templateMixin],
//   mounted() {
//     // Inicializa as funcionalidades específicas do footer
//     this.initScrollTop();
//   },
//   created() {

export default {
  name: "Footer",
  mixins: [templateMixin],
  mounted() {
    this.initScrollTop();
    const btn = document.getElementById("btnInstall");
    if (btn) {
      btn.addEventListener("click", async () => {
        if (this.deferredPrompt) {
          this.deferredPrompt.prompt();
          const { outcome } = await this.deferredPrompt.userChoice;
          this.deferredPrompt = null;
        }
      });
    }
    const btn2 = document.getElementById("btnInstall2");
    if (btn2) {
      btn2.addEventListener("click", async () => {
        if (this.deferredPrompt) {
          this.deferredPrompt.prompt();
          const { outcome } = await this.deferredPrompt.userChoice;
          this.deferredPrompt = null;
        }
      });
    }
  },
  data() {
    return {
      deferredPrompt: null,
    };
  },
  created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      const btn = document.getElementById("btnInstall");
      if (btn) btn.style.display = "block";
    });
  },
};
</script>


<style lang="scss">
.footer .footer-main .footer-links li:before {
  display: none !important;
}
.footer-links {
  margin-left: -15px !important;
}


.social-content {
  h2 {
    font-weight: 800;
    color: #fff;
  }

  p {
    color: var(--mx3-style-text-muted, #9ca3af);
  }
}

.social-links {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: rgba(0, 217, 255, 0.1);
  border: 2px solid rgba(0, 217, 255, 0.3);
  border-radius: 50%;
  color: var(--mx3-style-primary, #00d9ff);
  font-size: 1.5rem;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 217, 255, 0.3);
  }
  
  &.facebook {
    background: #1877F2;
    border-color: #1877F2;
    color: white;
    box-shadow: 0 10px 30px rgba(24, 119, 242, 0.4);
  }
  
  &.instagram {
    background: linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4);
    border-color: #DD2A7B;
    color: white;
    box-shadow: 0 10px 30px rgba(221, 42, 123, 0.4);
  }
  
  &.twitter {
    background: #000000;
    border-color: #000000;
    color: white;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  }
  
  &.linkedin {
    background: #0A66C2;
    border-color: #0A66C2;
    color: white;
    box-shadow: 0 10px 30px rgba(10, 102, 194, 0.4);
  }
}
</style>